import AFindInPageContent from './index.vue';

AFindInPageContent.install = app => {
  app.component(AFindInPageContent.name, AFindInPageContent);
};

export default AFindInPageContent;
